var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useEffect, useState, useMemo } from 'react';
import { getSuiClient } from '../utils/client';
const suiClient = getSuiClient('mainnet');
export const useSuinsNames = (addresses) => {
    const [suinsNames, setSuinsNames] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const addressesKey = useMemo(() => addresses.sort().join(','), [addresses]);
    useEffect(() => {
        if (!addresses || addresses.length === 0) {
            setSuinsNames({});
            return;
        }
        const fetchSuinsNames = () => __awaiter(void 0, void 0, void 0, function* () {
            setIsLoading(true);
            try {
                const namesMap = {};
                yield Promise.all(addresses.map((address) => __awaiter(void 0, void 0, void 0, function* () {
                    var _a;
                    try {
                        const objects = yield suiClient.listOwnedObjects({
                            owner: address,
                            type: '0xd22b24490e0bae52676651b4f56660a5ff8022a2576e0089f79b3c88d44e08f0::suins_registration::SuinsRegistration',
                        });
                        if (objects.objects && objects.objects.length > 0) {
                            const firstObject = objects.objects[0];
                            if (firstObject) {
                                const objectDetails = yield suiClient.getObject({
                                    objectId: firstObject.objectId,
                                    include: {
                                        json: true,
                                    },
                                });
                                const fields = (_a = objectDetails.object) === null || _a === void 0 ? void 0 : _a.json;
                                const domainName = fields === null || fields === void 0 ? void 0 : fields.domain_name;
                                if (domainName) {
                                    // Remove .sui suffix if it exists
                                    const displayName = domainName.endsWith('.sui')
                                        ? domainName.slice(0, -4)
                                        : domainName;
                                    namesMap[address] = displayName;
                                    return;
                                }
                            }
                        }
                        namesMap[address] = null;
                    }
                    catch (error) {
                        console.error(`Error fetching SuiNS name for ${address}:`, error);
                        namesMap[address] = null;
                    }
                })));
                setSuinsNames(namesMap);
            }
            catch (error) {
                console.error('Error fetching SuiNS names:', error);
                setSuinsNames({});
            }
            finally {
                setIsLoading(false);
            }
        });
        fetchSuinsNames();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addressesKey]);
    return { suinsNames, isLoading };
};
